import Loading from "components/common/Loading";
import VisaStatusCard from "components/home/VisaStatusCard";
import VisaType from "components/home/VisaType";
import { HOME_TAB, SMART_T_STEP } from "libs/constant/Step";
import { get } from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSmartFormList2 } from "redux/modules/ownVisaSlice";
import { setHomeTab, setSmartFormStep } from "redux/modules/uiSlice";
import ContentTitle from "components/common/ContentTitle";

import {
  getListSmartForm,
  selectListSmartForm,
  setSmartServiceId,
} from "redux/modules/visaForm";

function SmartServiceTab() {
  const dispatch = useDispatch();
  const listSmartFormState = useSelector(selectListSmartForm);
  const hasCreatedSmartForm = listSmartFormState.data.length;
  const { personalID } = useSelector((state) => state.personal.detail);
  const { list: ownVisaList } = useSelector((state) => state.ownVisa);

  const hasSmartFormComplete = listSmartFormState.data.some(
    (v) => v.statusDocName === "Completed"
  );
  const hasSmartFormDraft = listSmartFormState.data.some(
    (v) => v.statusDocName === "Draft"
  );
  const smartFormDraft = listSmartFormState.data.filter(
    (v) => v.statusDocName === "Draft"
  );
  const shouldShowContinue = hasCreatedSmartForm && hasSmartFormDraft;
  const shouldShowVisaType = !hasCreatedSmartForm;
  const smartserviceId = get(smartFormDraft, "0.smartserviceId", "");

  useEffect(() => {
    const body = {
      isActivated: true,
      personalId: personalID,
    };
    dispatch(getListSmartForm());
    dispatch(getSmartFormList2(body));
  }, [dispatch]);

  const handleClickContinue = () => {
    if (smartserviceId) {
      dispatch(setSmartServiceId(smartserviceId));
      dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_PASSPORT));
      dispatch(setHomeTab(HOME_TAB.CHECK_STATUS));
    }
  };

  console.log(ownVisaList);
  return (
    <div>
      {/* <TargetIndustries /> */}

      <ContentTitle subTitle="" title="Smart Visa" />
      <VisaType />
      {listSmartFormState.isLoading ? (
        <div style={{ marginTop: 24 }}>
          <Loading />
        </div>
      ) : (
        <>
          {/* {shouldShowContinue && (
                        <div style={{ marginTop: 24 }}>
                            <Paper style={{ padding: 24 }}>
                                <ContentTitle
                                    atitle="Continue you process"
                                    title="Application Form is not finished yet."
                                    subTitle="Smart form document"
                                />
                                <div style={{ marginTop: 16 }} />
                                <ColorButton
                                    variant="contained"
                                    color="success"
                                    onClick={handleClickContinue}
                                >
                                    Continue process..
                                </ColorButton>{" "}
                            </Paper>
                        </div>
                    )} */}
          {/* {shouldShowVisaType && <VisaType />} */}
          {/* {hasSmartFormComplete && <VisaStatusCard />} */}
          {/* {
            ownVisaList.length > 0 &&
            <VisaStatusCard />
          } */}

          <VisaStatusCard />
        </>
      )}

      {/* <TypeOfSmartVisa /> */}
    </div>
  );
}

export default SmartServiceTab;
